import React, { Fragment } from 'react';
import Expression from './Expression';

export default function CustomFilterExpressions ({ expressions, fields, disableUnique, overrideStringOperators, handleUpdateExpression, 
  handleRemoveExpression, statusOptions, isDropdownLoading, setIsDropdownLoading, userInfo, datasetSelection }) {
    const currentExpressionsKeys = Object.keys(expressions);
    return (
      <Fragment>
      {currentExpressionsKeys?.map(id => {
      const expression = expressions[id];
      return (
        <Fragment key={id}>
        <Expression
          id={id}
          disableUnique={disableUnique}
          overrideStringOperators={overrideStringOperators}
          expressionDef={expression}
          fields={fields}
          updateExpression={handleUpdateExpression}
          removeExpression={handleRemoveExpression}
          statusOptions={statusOptions}
          isDropdownLoading={isDropdownLoading}
          setIsDropdownLoading={setIsDropdownLoading}
          userInfo={userInfo}
          datasetSelection={datasetSelection}
        />
        </Fragment>
      );
    })}
    </Fragment>
  )
}
